import { render, staticRenderFns } from "./PlanejamentoAcaoFormResumo.vue?vue&type=template&id=5e420298"
import script from "./PlanejamentoAcaoFormResumo.vue?vue&type=script&lang=js"
export * from "./PlanejamentoAcaoFormResumo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports